import HttpService from "@/utils/httpData"

export default {
    filter(data) {
        let apiEndpoint = `exam/List`;
        let params = data
        return HttpService.post(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

    getById(id) {
        let apiEndpoint = `exam/Detail`;
        let params = {
            examId: id
        }
        return HttpService.get(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

    add(data) {
        let apiEndpoint = `exam/add`;
        let params = data;
        return HttpService.post(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

    edit(data) {
        let apiEndpoint = `exam/edit`;
        let params = data;
        return HttpService.post(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

    delete(id) {
        let apiEndpoint = `exam/delete`;
        let params = {
            id: id
        };
        return HttpService.post(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

    exportQuestion(data) {
        let apiEndpoint = `exam/ExportQuestion`;
        let params = data;
        return HttpService.post(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

    exportAnswer(data) {
        let apiEndpoint = `exam/ExportAnswer`;
        let params = data;
        return HttpService.post(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },
}